const accessToken = () => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    
    if (obj && obj.idToken) {
      return obj.idToken;
    } else {
      return "";
    }
  };
  
  export default accessToken;